module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Copyright")]), _vm._v(" "), _c('p', {
    staticClass: "first",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Diversion Books"), _c('br'), _vm._v("\n  A Division of Diversion Publishing Corp."), _c('br'), _vm._v("\n  443 Park Avenue South, Suite 1004"), _c('br'), _vm._v("\n  New York, NY 10016"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.DiversionBooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.DiversionBooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Copyright © 1992 by Edna Buchanan"), _c('br'), _vm._v("\n  All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("This is a work of fiction. Names, characters, places and incidents either are the product of the author’s imagination or are used fictitiously. Any resemblance to actual persons, living or dead, events or locales is entirely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("For more information, email "), _c('a', {
    attrs: {
      "href": "mailto:info@diversionbooks.com"
    }
  }, [_vm._v("info@diversionbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("First Diversion Books edition April 2014"), _c('br'), _vm._v("\n  ISBN: "), _c('span', {
    staticStyle: {
      "font-size": "1em",
      "line-height": "1.375",
      "font-family": "'Liberation Serif', serif",
      "text-align": "justify"
    }
  }, [_vm._v("978-1-62681-246-8")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "page-break-after": "always"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("Do not cling to events of the past or dwell on what happened long ago. Watch for the new thing I am going to do. It is happening already—you can see it now!")]), _c('br'), _vm._v("\n  ISAIAH 43:18-19")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36ee8bb6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/1copyright.vue
// module id = 69
// module chunks = 0